import React, { useEffect, useState } from 'react';
import { HomeContent } from './homeContainer';
import NewBookModal from '../../components/newBookModal';
import Footer from './footer';
import { AboutUsSection } from './aboutUs';
import { StatsSection } from './successCard';
import { Managment } from './Managment';
import HowitWork from './howitWork';
import SupportForm from './supportForm';


// Variable outside component scope to persist during client-side navigation
let hasShownModal = false;

export function HomePage() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        // Show modal after 2 seconds, only if it hasn't been shown before
        if (!hasShownModal) {
            const timer = setTimeout(() => {
                setShowModal(true);
                hasShownModal = true;
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, []);


    useEffect(() => {
        window.scrollTo(0, 0);

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="w-full text-center min-h-screen relative overflow-hidden bg-gray-50">
            {/* Main content */}
            <div className="relative flex flex-col min-h-screen">
                <HomeContent isMobile={isMobile} />
                <AboutUsSection />
                <StatsSection />
                {/* <HowitWork /> */}
                {/* <SupportForm /> */}
                <Footer />
                {showModal && <NewBookModal onClose={() => setShowModal(false)} />}
            </div>
        </div>
    );
}
